import { useContext } from "react";
import { mainContext } from "@ts/constants";
import { onFileUploadClickHandler } from "@ts/utils";
import { ICellRendererParams } from "ag-grid-community";
import { IMainContext } from "@ts/common-types";
import { FaUpload } from "react-icons/fa6";

const UploadButtonCellRenderer = (params: ICellRendererParams) => {
    const {
        setAssetResponse,
        setIsAssetUpload,
        setCampaignCreationConfigParams,
        setSelectedImageFilter,
    } = useContext<IMainContext>(mainContext);

    return (
        <div
            style={{
                width: "100%",
                height: "2em",
            }}
        >
            <button
                id={`uploadCustomImageBtn-${params.node.rowIndex}`}
                className="btn"
                style={{
                    display:
                        params.data.campaignType === "sponsoredProducts"
                            ? "none"
                            : "grid",
                    placeContent: "center",
                    background: "none",
                    border: "none",
                }}
                onClick={() => {
                    setCampaignCreationConfigParams(params);
                    onFileUploadClickHandler(
                        setIsAssetUpload,
                        setAssetResponse,
                        false,
                        setSelectedImageFilter
                    );
                }}
            >
                <FaUpload className="content" style={{
                        fontSize: "20px",
                    }}/>
            </button>
        </div>
    );
};

export default UploadButtonCellRenderer;
